import { render, staticRenderFns } from "./ClientsSlider.vue?vue&type=template&id=89d1abde"
import script from "./ClientsSlider.vue?vue&type=script&lang=js"
export * from "./ClientsSlider.vue?vue&type=script&lang=js"
import style0 from "./ClientsSlider.vue?vue&type=style&index=0&id=89d1abde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports